/*
Taken from https://github.com/atanas-dev/vue-router-multiguard/blob/master/index.js,

Didn't want to pull in package for sake of a one-file library that hasn't changed in 3 years
*/
type Route = import('vue-router').Route;
type NavigationGuardNext = import('vue-router').NavigationGuardNext;
type NavigationGuard = import('vue-router').NavigationGuard;

function isUndefined(value: unknown): value is undefined {
	return value === undefined;
}

function evaluateGuards(guards: Array<NavigationGuard>, to: Route, from: Route, next: NavigationGuardNext) {
	const guardsLeft = guards.slice(0); // clone the array so we do not accidentally modify it
	const nextGuard = guardsLeft.shift();

	if (isUndefined(nextGuard)) {
		next();
		return;
	}

	nextGuard(to, from, (nextArg) => {
		if (isUndefined(nextArg)) {
			evaluateGuards(guardsLeft, to, from, next);
			return;
		}

		next(nextArg);
	});
}

export function multiGuard(guards: Array<NavigationGuard>): NavigationGuard {
	if (!Array.isArray(guards)) {
		throw new Error('You must specify an array of guards');
	}

	return (to, from, next) => {
		return evaluateGuards(guards, to, from, next);
	};
}
